<template>
  <!-- <div class="ali-screens fixed-grid min-width">
    <figure id="ali-windows">
      <div
        id="ali-screens-1"
        class="c-2-5 r-1 relative"
        :class="{ zoomed: zoomed }"
      >
        <svg
          viewBox="0 0 489 768"
          class="pointer-plus"
          @click="handleExpand($event, 'ali-screens-1')"
        >
          <path d="M171 97h318v191H171z" fill="#000" />
          <image
            x="171"
            y="97"
            width="318"
            height="191"
            href="@/assets/work/alibaba/content/key-screens/window-log-in.png"
          />
          <path d="M0 312h489v367H0z" fill="#000" />
          <image
            x="0"
            y="312"
            width="489"
            height="367"
            href="@/assets/work/alibaba/content/key-screens/window-workspace.png"
          />
        </svg>
        <object
          class="back left no-event"
          type="image/svg+xml"
          :data="svgLib.screens1"
        />
      </div>
      <div
        id="ali-screens-2"
        class="c-5-8 r-1 relative"
        :class="{ zoomed: zoomed }"
      >
        <svg
          viewBox="0 0 489 768"
          class="pointer-plus"
          @click="handleExpand($event, 'ali-screens-2')"
        >
          <path d="M0 312h489v367H0z" fill="#000" />
          <image
            x="0"
            y="312"
            width="489"
            height="367"
            href="@/assets/work/alibaba/content/key-screens/window.png"
          />
          <image
            x="49"
            y="102"
            width="98"
            height="225"
            href="@/assets/work/alibaba/content/key-screens/search.png"
          />
        </svg>
        <object
          class="back left no-event"
          type="image/svg+xml"
          :data="svgLib.screens2"
        />
      </div>
      <div
        id="ali-screens-3"
        class="c--5--2 r-1 relative"
        :class="{ zoomed: zoomed }"
      >
        <svg
          viewBox="0 0 489 768"
          class="pointer-plus"
          @click="handleExpand($event, 'ali-screens-3')"
        >
          <path fill-opacity="0.15" fill="#00baff" d="M147 346h338v333H147z" />
          <g class="anime-opacity" opacity="0">
            <path d="M-342 312h489v367h-489z" fill="#000" />
            <image
              x="-342"
              y="312"
              width="489"
              height="367"
              href="@/assets/work/alibaba/content/key-screens/window.png"
            />
          </g>
          <image
            x="342"
            y="346"
            width="143"
            height="333"
            href="@/assets/work/alibaba/content/key-screens/panel-3.png"
          />
          <image
            x="171"
            y="346"
            width="143"
            height="333"
            href="@/assets/work/alibaba/content/key-screens/panel-2.png"
          />
          <image
            x="171"
            y="44"
            width="143"
            height="244"
            href="@/assets/work/alibaba/content/key-screens/deploy-short.png"
          />
        </svg>
        <object
          class="back left no-event"
          type="image/svg+xml"
          :data="svgLib.screens3"
        />
      </div>
    </figure>
  </div>-->
  <div :id="figId + '-wrapper'" class="fixed-grid min-width" :class="[figId]">
    <figure :id="figId">
      <svg
        viewBox="0 0 1440 768"
        class="c-1--1 r-1 anime-viewbox"
        :class="{
          zoomed: zoomed,
          animating: animating,
          'pointer-plus': !zoomed,
          'pointer-minus': zoomed
        }"
        data-viewbox="0 0 1440 3110"
        @click="handleExpand"
      >
        <title>Click to expand details</title>
        <g
          id="ali-screen-3"
          class="anime-translate"
          data-dx="-346"
          data-dy="2070"
        >
          <rect
            id="ali-projection"
            fill-opacity="0.15"
            fill="#00BAFF"
            x="1050"
            y="312"
            width="390"
            height="367"
            class="anime-resize anime-translate"
            data-width="879"
            data-height="566"
            data-dx="-144"
            data-dy="34"
          />
          <g id="ali-panel-3">
            <image
              x="1245"
              y="346"
              width="143"
              height="333"
              class="anime-scale-size anime-translate"
              data-scale="1.7"
              data-dx="250"
              data-dy="0"
              href="@/assets/work/alibaba/content/key-screens/panel-3.png"
            />
            <path
              d="M1257,624 L1257,696"
              class="anime-translate ali-pointer"
              data-dx="250"
              data-dy="233"
            />
            <text
              class="anime-translate text-body"
              text-anchor="start"
              x="1245"
              y="712"
              data-dx="250"
              data-dy="233"
            >
              <tspan class="text-title">INTERACTIONS</tspan>
              <tspan x="1245" dy="24">Assign callbacks for</tspan>
              <tspan x="1245" dy="18">interaction events</tspan>
            </text>
          </g>
          <g id="ali-panel-2">
            <image
              x="1074"
              y="346"
              width="143"
              height="333"
              class="anime-scale-size anime-translate"
              data-scale="1.7"
              data-dx="125"
              data-dy="0"
              href="@/assets/work/alibaba/content/key-screens/panel-2.png"
            />
            <path
              d="M1148,624 L1148,696"
              class="anime-translate ali-pointer"
              data-dx="179"
              data-dy="233"
            />
            <text
              class="anime-translate text-body"
              text-anchor="middle"
              x="1148"
              y="712"
              data-dx="179"
              data-dy="233"
            >
              <tspan class="text-title">DATA VIEW</tspan>
              <tspan x="1148" dy="24">Link / Edit</tspan>
              <tspan x="1148" dy="18">component data</tspan>
            </text>
          </g>
          <g>
            <image
              id="ali-panel-1"
              x="907"
              y="346"
              width="143"
              height="333"
              class="anime-scale-size anime-opacity"
              data-scale="1.7"
              opacity="0"
              data-opacity="1"
              href="@/assets/work/alibaba/content/key-screens/property-panel.png"
            />
            <g class="anime-translate" data-dx="100" data-dy="233">
              <path d="M1038,624 L1038,696" class="ali-pointer" />
              <text class="text-body" text-anchor="end" x="1050" y="712">
                <tspan class="text-title">STYLE PROPERTIES</tspan>
                <tspan x="1050" dy="24">Adjust component</tspan>
                <tspan x="1050" dy="18">styles &amp; attributes</tspan>
              </text>
            </g>
          </g>
          <path
            d="M1244.5,348.5 L1253.5,353 L1244.5,357.5 L1244.5,353.5 L1217.5,353.5 L1217.5,357.5 L1208.5,353 L1217.5,348.5 L1217.5,352.5 L1244.5,352.5 L1244.5,348.5 Z"
            class="anime-translate ali-arrow"
            data-dx="236"
            data-dy="6"
          />
          <path
            d="M1093.5,348.5 L1102.5,353 L1093.5,357.5 L1093.5,353.5 L1068.5,353.5 L1068.5,357.5 L1059.5,353 L1068.5,348.5 L1068.5,352.5 L1093.5,352.5 L1093.5,348.5 Z"
            class="anime-translate ali-arrow"
            data-dx="96"
            data-dy="6"
          />
        </g>

        <g id="ali-screen-2" class="anime-translate" data-dx="0" data-dy="1299">
          <g id="ali-search">
            <image
              x="610"
              y="102"
              width="98"
              height="225"
              class="anime-scale-size anime-translate"
              data-scale="1.63"
              data-dx="6"
              data-dy="-118"
              href="@/assets/work/alibaba/content/key-screens/search.png"
            />
            <g class="anime-translate" data-dx="66" data-dy="-132">
              <path d="M631,88 L631,120" class="ali-pointer" />
              <text class="text-body" text-anchor="end" x="708" y="40">
                <tspan class="text-title">SEARCH</tspan>
                <tspan x="708" dy="24">Search for component</tspan>
                <tspan x="708" dy="18">delopy version / test case</tspan>
              </text>
            </g>
          </g>
          <g id="ali-window">
            <g>
              <rect
                fill="#000000"
                x="561"
                y="312"
                width="489"
                height="367"
                class="anime-scale-size"
                data-scale="1.7"
              />
              <image
                x="561"
                y="312"
                width="489"
                height="367"
                class="anime-scale-size"
                data-scale="1.7"
                href="@/assets/work/alibaba/content/key-screens/window.png"
              />
            </g>

            <g class="anime-translate" data-dx="68" data-dy="0">
              <path d="M744,280 L744,336" class="ali-pointer" />
              <text class="text-body" text-anchor="start" x="732" y="232">
                <tspan class="text-title">COMPONENT TABS</tspan>
                <tspan x="732" dy="24">Switch among different</tspan>
                <tspan x="732" dy="18">components to work on</tspan>
              </text>
            </g>
            <g class="anime-translate" data-dx="320" data-dy="0">
              <path d="M1022,280 L1022,336" class="ali-pointer" />
              <text class="text-body" text-anchor="end" x="1050" y="232">
                <tspan class="text-title">TOOL BAR</tspan>
                <tspan x="1050" dy="24">Quick switch between</tspan>
                <tspan x="1050" dy="18">preview &amp; test</tspan>
              </text>
            </g>
            <g class="anime-translate" data-dx="342" data-dy="929">
              <path
                d="M915,142 L915,356"
                class="anime-opacity ali-pointer"
                data-opacity="0"
              />
              <text class="text-body" text-anchor="start" x="903" y="40">
                <tspan class="text-title">PROPERTIES PANEL</tspan>
                <!-- eslint-disable-next-line prettier/prettier -->
                <tspan x="903" dy="24">Preview &amp; adjust properties</tspan>
                <tspan x="903" dy="18">for the component</tspan>
                <tspan x="903" dy="18">&nbsp;</tspan>
                <tspan x="903" dy="18">Switch among style / data /</tspan>
                <tspan x="903" dy="18">interaction properties</tspan>
              </text>
            </g>
            <g class="anime-translate" data-dx="342" data-dy="257">
              <path d="M1038,624 L1038,696" class="ali-pointer" />
              <text
                class="anime-opacity text-body"
                data-opacity="0"
                text-anchor="end"
                x="1050"
                y="712"
              >
                <tspan class="text-title">STYLE PROPERTIES</tspan>
                <tspan x="1050" dy="24">Adjust component</tspan>
                <tspan x="1050" dy="18">styles &amp; attributes</tspan>
              </text>
            </g>
            <g class="anime-translate" data-dx="171" data-dy="257">
              <path d="M780,576 L780,696" class="ali-pointer" />
              <text class="text-body" text-anchor="start" x="732" y="712">
                <tspan class="text-title">PREVIEW CANVAS</tspan>
                <tspan x="732" dy="24">Component preview</tspan>
              </text>
            </g>
            <g class="anime-translate" data-dx="12" data-dy="257">
              <path d="M577,672 L577,696" class="ali-pointer" />
              <text class="text-body" text-anchor="start" x="561" y="712">
                <tspan class="text-title">SIDE BAR</tspan>
                <tspan x="561" dy="24">Quick links</tspan>
                <tspan x="561" dy="18">Access to acount home</tspan>
              </text>
            </g>
          </g>
          <path
            d="M563.5,515.5 L572.5,520 L563.5,524.5 L563.5,520.5 L516,520.5 L516,519.5 L563.5,519.5 L563.5,515.5 Z"
            class="anime-opacity ali-arrow"
            opacity="1"
            data-opacity="0"
          />
          <g id="ali-deploy-short">
            <image
              x="1074"
              y="44"
              width="143"
              height="244"
              class="anime-scale-size anime-translate"
              data-scale="1.7"
              data-dx="-96"
              data-dy="-172"
              href="@/assets/work/alibaba/content/key-screens/deploy-short.png"
            />
            <g class="anime-translate" data-dx="0" data-dy="-114">
              <path d="M1213,228 L1241,228" class="ali-pointer" />
              <text class="text-body" text-anchor="start" x="1245" y="232">
                <tspan class="text-title">DEPLOY PANEL</tspan>
                <tspan x="1245" dy="24">Manage component</tspan>
                <tspan x="1245" dy="18">deployments / versions</tspan>
              </text>
            </g>
          </g>
          <path
            d="M1080,275.5 L1084.5,284.5 L1080.5,284.5 L1080.5,336.5 L1046,336.5 L1046,335.5 L1079.5,335.5 L1079.5,284.5 L1075.5,284.5 L1080,275.5 Z"
            class="anime-opacity ali-arrow"
            opacity="1"
            data-opacity="0"
          />
          <path
            d="M611.5,271.5 L620.5,276 L611.5,280.5 L611.5,276.5 L602.5,276.5 L602.5,326 L601.5,326 L601.5,275.5 L611.5,275.5 L611.5,271.5 Z"
            class="ali-arrow"
          />
        </g>

        <g id="ali-screen-1" class="anime-translate" data-dx="513" data-dy="0">
          <g
            id="ali-window-log-in"
            class="anime-translate"
            data-dx="-171"
            data-dy="0"
          >
            <g>
              <rect
                fill="#000000"
                x="219"
                y="97"
                width="318"
                height="191"
                class="anime-scale-size"
                data-scale="1.7"
              />
              <image
                x="219"
                y="97"
                width="318"
                height="191"
                href="@/assets/work/alibaba/content/key-screens/window-log-in.png"
                class="anime-scale-size"
                data-scale="1.7"
              />
            </g>

            <g class="anime-translate" data-dx="223" data-dy="0">
              <path d="M525,88 L525,120" class="ali-pointer" />
              <text class="text-body" text-anchor="end" x="537" y="40">
                <tspan class="text-title">WORKSPACES</tspan>
                <tspan x="537" dy="24">Create / manage local</tspan>
                <tspan x="537" dy="18">component workspaces</tspan>
              </text>
            </g>
            <path d="M259,88 L259,192.5" class="ali-pointer" />
            <g>
              <text class="text-body" text-anchor="start" x="219" y="40">
                <tspan class="text-title">ACCOUNT HOME</tspan>
                <tspan x="219" dy="24">Sign in / switch account</tspan>
                <tspan x="219" dy="18">Quick links</tspan>
              </text>
            </g>
          </g>
          <g
            id="ali-window-workspace"
            class="anime-translate"
            data-dx="0"
            data-dy="157"
          >
            <g>
              <rect
                fill="#000000"
                x="48"
                y="312"
                width="489"
                height="367"
                class="anime-scale-size"
                data-scale="1.7"
              />
              <image
                x="48"
                y="312"
                width="489"
                height="367"
                class="anime-scale-size"
                data-scale="1.7"
                href="@/assets/work/alibaba/content/key-screens/window-workspace.png"
              />
            </g>
            <g class="anime-translate" data-dx="342" data-dy="257">
              <path d="M525,648 L525,696" class="ali-pointer" />
              <text class="text-body" text-anchor="end" x="537" y="712">
                <tspan class="text-title">NEW COMPONENT</tspan>
                <tspan x="537" dy="24">Create / import &amp; edit</tspan>
                <tspan x="537" dy="18">component information</tspan>
              </text>
            </g>
            <g class="anime-translate" data-dx="-60" data-dy="257">
              <path d="M167,648 v60 h48" class="ali-pointer" />
              <text class="text-body" text-anchor="start" x="219" y="712">
                <tspan class="text-title">WORKSPACE PANEL</tspan>
                <tspan x="219" dy="24">Manage components within</tspan>
                <tspan x="219" dy="18">the workspace</tspan>
              </text>
            </g>
          </g>
          <path
            d="M419.5,284 L419.5,327.5 L423.5,327.5 L419,336.5 L414.5,327.5 L418.5,327.5 L418.5,284 L419.5,284 Z"
            class="anime-translate ali-arrow"
            data-dx="0"
            data-dy="136"
          />
        </g>
      </svg>
      <figcaption class="c-x--2 r-1 line text-second">
        Key screens of the delivered hi-fi UI designs.
      </figcaption>
      <transition name="fade" mode="out-in">
        <figcaption class="r-1 anno compact" v-show="zoomed">
          <div></div>
          <div>
            <p class="overline theme-alibaba bold">Login</p>
            <p>Log in to the app, manage developer account and quick links.</p>
            <p>Create and manage workspaces.</p>
          </div>
          <div>
            <p class="overline theme-alibaba bold">Workspace</p>
            <p>Manage local components in the current workspace.</p>
            <p>Create / import new local components.</p>
          </div>
          <div>
            <p class="overline theme-alibaba bold">Deploy</p>
            <p>Deploy local components to online platform.</p>
            <p class="margin1-b">Manage deployment versions.</p>
            <p class="overline theme-alibaba bold">Search</p>
            <p>Search for components in the current workspace.</p>
          </div>
          <div>
            <p class="overline theme-alibaba bold">Preview</p>
            <p>Preview and test local components before deployment.</p>
            <p>Inspect and adjust details of local components.</p>
          </div>
          <div>
            <p class="overline theme-alibaba bold">Preview</p>
            <p class="overline theme-alibaba">(Properties Panel)</p>
            <p>Detailed component properties.</p>
            <p>
              Adjust style properties, plug in data for testing and add
              interactions.
            </p>
          </div>
        </figcaption>
      </transition>
    </figure>
  </div>
</template>

<style lang="scss">
@import '@/styles/base.scss';

.ali-screens {
  figcaption.anno {
    grid-column: 2 / span 3;
    display: grid;
    grid-template-rows: 97fr 372fr 702fr 440fr 805fr 694fr;
  }
}
@media only screen and (min-width: $mid-width) {
  .ali-screens {
    figcaption.anno {
      grid-column: 3 / span 2;
    }
  }
}

// .ali-screens-text-body {
//   font-size: $svg-text-body;
//   line-height: $svg-line-body;
//   font-weight: 300;
//   letter-spacing: -0.685714286;
//   fill: $text-light;
// }
// .ali-screens-text-title {
//   font-size: $svg-text-title;
//   line-height: $svg-line-title;
//   fill: $text-light-second;
//   font-weight: 600;
// }
</style>

<script>
import anime from 'animejs'

export default {
  name: 'ali-screens',
  data() {
    return {
      svgLib: {
        screens1: require('@/assets/work/alibaba/content/key-screens/ali-screens-1.svg'),
        screens2: require('@/assets/work/alibaba/content/key-screens/ali-screens-2.svg'),
        screens3: require('@/assets/work/alibaba/content/key-screens/ali-screens-3.svg')
      },
      figId: 'ali-screens',
      zoomed: false,
      animating: false,
      animeList: [],
      animViewBox: {
        animation: null,
        isPlaying: false,
        isActive: false
      },
      animeOptions: this.$store.state.work.defaultAnimOptions,
      animePresets: this.$store.state.work.dafaultAnimPresets,
      expandAnimeOptions: [
        // {
        //   preset: { name: '.anime-viewbox' }
        // },
        {
          preset: { name: '.anime-translate' }
        },
        {
          preset: { name: '.anime-scale-size' }
        },
        {
          preset: { name: '.anime-resize' }
        },
        {
          preset: { name: '.anime-opacity' }
        }
      ]
    }
  },
  computed: {},
  methods: {
    addAnimation(options) {
      // animeList item to be added
      let anim = {
        animation: null,
        isPlaying: false,
        isActive: false
      }
      // anime options to use (w/ default event handling & animation properties)
      let useOptions = {
        changeBegin: () => {
          anim.isPlaying = true
          // console.log('start')
        },
        changeComplete: a => {
          anim.isPlaying = false
          // console.log('end')
          a.reverse()
          anim.isActive = !anim.isActive
          // console.log('reversed')
        },
        easing: this.animeOptions.easing, // easeInOutSine
        duration: 500, // 300
        autoplay: this.animeOptions.autoplay // false
      }

      // check for anime presets
      if ('preset' in options) {
        // add animation targets
        useOptions.targets = '#' + this.figId + ' ' + options.preset.name
        // merge preset params
        Object.assign(useOptions, this.animePresets[options.preset.name])
        // pop preset flag from options
        delete useOptions.preset
      }
      if ('stagger' in options) {
        // console.log(options.stagger)
        // console.log(this.animeOptions.staggerDelay)
        // add staggered delay
        if (options.stagger > 0) {
          useOptions.delay = anime.stagger(options.stagger)
        } else {
          useOptions.delay = anime.stagger(this.animeOptions.staggerDelay)
        }
        // pop preset flag from options
        delete options.stagger
      }

      // merge anime options
      Object.assign(useOptions, options)

      // Init animation
      if ('targets' in useOptions) {
        anim.animation = anime(useOptions)
      }
      // console.log(anim)

      // push to animeList
      this.animeList.push(anim)
      // console.log(this.animeList)
    },
    playAnimeList() {
      let animeListFinished = []
      this.animating = true
      this.animeList.forEach(item => {
        if (item.isPlaying) {
          // wait if animations are playing
          item.animation.finished.then(() => {
            // play animations if animations are not active
            item.animation.play()
          })
        } else {
          // play animations if animations are not active
          item.animation.play()
        }
        animeListFinished.push(item.animation.finished)
      })
      return animeListFinished
    },
    async handleExpand(event) {
      // console.log(event.target.tagName)
      let zoomOnce = true
      if (this.animating) {
        await this.animViewBox.animation.finished
      }
      this.animating = true
      if (zoomOnce && this.zoomed) {
        this.zoomed = false
        zoomOnce = false
      }
      await Promise.all(this.playAnimeList())
      this.animViewBox.animation.play()
      await this.animViewBox.animation.finished
      // console.log(this.animViewBox.isActive, this.zoomed)
      if (zoomOnce && !this.zoomed) {
        this.zoomed = true
        zoomOnce = false
      }
      if (!this.zoomed) {
        this.$scrollTo('#workflow')
      }
      this.animating = false
    }
  },
  mounted() {
    // Init animeList to hold all hover animations
    this.expandAnimeOptions.forEach(el => {
      this.addAnimation(el)
    })
    this.animViewBox.animation = anime({
      targets: '#' + this.figId + ' .anime-viewbox',
      viewBox: el => {
        return el.getAttribute('data-viewbox')
      },
      changeBegin: () => {
        this.animViewBox.isPlaying = true
        // console.log('start')
      },
      changeComplete: a => {
        this.animViewBox.isPlaying = false
        // console.log('end')
        a.reverse()
        this.animViewBox.isActive = !this.animViewBox.isActive
        // console.log('reversed')
      },
      easing: this.animeOptions.easing, // easeInOutSine
      duration: 500,
      autoplay: this.animeOptions.autoplay // false
    })
    // console.log(this.animeList)
  }
}
</script>
